export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "back_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Précédent"])},
        "tab_organizations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vue organisations"])},
        "tab_stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vue points de vente"])}
      },
      "en": {
        "back_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
        "tab_organizations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organizations view"])},
        "tab_stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stores view"])}
      }
    }
  })
}
